import Skeleton from '../../reusable/Skeleton/Skeleton';
import { t } from '../../i18n/i18n';
import './TradeHistory.scss';

/**
 * The trade-detail chart card while `GET /trade-history/` is in flight — 1:11716.
 *
 * Only this card needs one. The table below already draws skeleton rows of its
 * own, and the candles call has its own note inside the plot well, which only
 * matters once a trade has been picked.
 *
 * Without it the card reads as genuinely empty on first paint — "Trade history
 * — N/A" over "No trade selected" — which is what the card says when a trade
 * really is missing, not when one is still on its way.
 */
export default function ChartCardSkeleton() {
  return (
    <section className="th-chart-card" aria-busy="true" aria-label={t('Loading trade chart')}>
      <header className="th-chart-card__head">
        <div className="th-chart-card__title">
          <Skeleton w="18px" h={18} />
          <Skeleton w="220px" h={14} />
        </div>

        <div className="th-chart-card__controls">
          <Skeleton w="148px" h={32} />
          <Skeleton w="196px" h={32} />
        </div>
      </header>

      <div className="th-chart-card__summary">
        <div className="th-chart-card__symbol">
          <Skeleton w="24px" h={24} radius={5} />
          <Skeleton w="176px" h={13} />
        </div>
        <Skeleton w="232px" h={13} />
      </div>

      <Skeleton w="100%" h={224} />
    </section>
  );
}
